export default "__VITE_ASSET__1$TR0jfP__"